<mk-loader *ngIf="isLoading" class="loader-spinner"></mk-loader>
<div class="modal-header">
    <h6 class="modal-title" id="modal-basic-title">Proceso de Seleccion</h6>
    <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<aw-wizard #wizard class="mt-3">
    <aw-wizard-step [stepTitle]="'Etapa 0'">
        <div class="modal-body">
            <div class="mensaje-informativo">
                <i class="fa fa-search megaIcon" aria-hidden="true"></i>
                <h4 class="subtitulo">Etapa 0</h4>
                <h2 class="titulo">Aplicación en Mi Kiosko</h2>
                <p class="descripcion">
                    Se revisan los últimos 3 meses en tu Kardex, buscando que no tengas faltas injustificadas, acciones disciplinarias o más de 3 retardos. Recuerda revisar regularmente los mensajes en la aplicación.
                </p>
            </div>
        </div>
        <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-dark" awNextStep >Siguiente</button>
        </div>
    </aw-wizard-step>
    <aw-wizard-step [stepTitle]="'Etapa 1'">
        <div class="modal-body">
            <div class="mensaje-informativo">
                <i class="fa fa-user megaIcon" aria-hidden="true"></i>
                <h4 class="subtitulo">Etapa 1</h4>
                <h2 class="titulo">Entrevista de Recursos Humanos</h2>
                <p class="descripcion">
                    Nos estaremos comunicando contigo para revisar tu experiencia, conocimientos y si puedes continuar con el proceso.
                </p>
            </div>
        </div>
        <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-warning" awPreviousStep>Atras</button>
            <button type="button" class="btn btn-dark" awNextStep >Siguiente</button>
        </div>
    </aw-wizard-step>
    <aw-wizard-step [stepTitle]="'Etapa 2'">
        <div class="modal-body">
            <div class="mensaje-informativo">
                <i class="fa fa-users megaIcon" aria-hidden="true"></i>
                <h4 class="subtitulo">Etapa 2</h4>
                <h2 class="titulo">Entrevista por parte del área contratante</h2>
                <p class="descripcion">
                    Puede ser más de una entrevista, para lo cual el personal de Recursos Humanos se estará comunicando con usted y su supervisor para el seguimiento.
                </p>
            </div>
        </div>
        <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-warning" awPreviousStep>Atras</button>
            <button type="button" class="btn btn-dark" awNextStep >Siguiente</button>
        </div>
    </aw-wizard-step>
    <aw-wizard-step [stepTitle]="'Etapa 3'">
        <div class="modal-body">
            <div class="mensaje-informativo">
                <i class="fa fa-file megaIcon" aria-hidden="true"></i>
                <h4 class="subtitulo">Etapa 3</h4>
                <h2 class="titulo">Aplicación de exámenes</h2>
                <p class="descripcion">
                    Se te aplicarán una serie de pruebas psicométricas, y en algunos casos, pruebas técnicas.
                </p>
            </div>
        </div>
        <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-warning" awPreviousStep> Atras </button>
            <button type="button" class="btn btn-dark" awNextStep >Siguiente</button>
        </div>
    </aw-wizard-step>
    <aw-wizard-step [stepTitle]="'Etapa 4'">
        <div class="modal-body">
            <div class="mensaje-informativo">
                <i class="fa fa-star megaIcon" aria-hidden="true"></i>
                <h4 class="subtitulo">Etapa 4</h4>
                <h2 class="titulo">Oferta</h2>
                <p class="descripcion">
                    Si eres seleccionado, se te extenderá una oferta que determinará tu tiempo a prueba y otros aspectos relacionados.
                </p>
            </div>
        </div>
        <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-warning" awPreviousStep> Atras </button>
            <button type="button" class="btn btn-dark" awNextStep >Siguiente</button>
        </div>
    </aw-wizard-step>
    <aw-wizard-completion-step [stepTitle]="'Etapa 5'" awEnableBackLinks>
        <div class="modal-body">
            <div class="mensaje-informativo">
                <i class="fa fa-exclamation megaIcon" aria-hidden="true"></i>
                <h4 class="subtitulo">Etapa 5</h4>
                <h2 class="titulo">¡Atención!</h2>
                <p class="descripcion">
                    Durante todo el proceso estaremos en contacto contigo a través de la aplicación. Puedes ver los avances al entrar a tu modulo de plan carrera.
                </p>
                <button type="button" class="btn btn-success" (click)="processComplete()"><b>Aplicar</b></button>
            </div>
        </div>
        <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-warning" awPreviousStep> Atras </button>
        </div>
    </aw-wizard-completion-step>
</aw-wizard>